// extracted by mini-css-extract-plugin
export default {"row":"rJSEmtt9_x9X_6NA98CC","noBranches":"sHPv_O3wL0mWss8hBfzf","title":"a6VycX2mwyWmEO_H9W_Y"};